var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c(
      "td",
      [
        _c("input-field", {
          attrs: {
            vMoney: "",
            format: _vm.decimal,
            id: "area" + _vm.$vnode.key,
            placeholder: "#,###.##"
          },
          model: {
            value: _vm.area.area,
            callback: function($$v) {
              _vm.$set(_vm.area, "area", $$v)
            },
            expression: "area.area"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "td",
      [
        _c("input-field", {
          attrs: {
            vMoney: "",
            format: _vm.money,
            id: "valor" + _vm.$vnode.key,
            placeholder: "#,###.##"
          },
          model: {
            value: _vm.area.valor,
            callback: function($$v) {
              _vm.$set(_vm.area, "valor", $$v)
            },
            expression: "area.valor"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "td",
      [
        _c("input-field", {
          attrs: {
            vMoney: "",
            format: _vm.decimal,
            id: "valor" + _vm.$vnode.key,
            placeholder: "#,###.##"
          },
          model: {
            value: _vm.area.hora_trabajo,
            callback: function($$v) {
              _vm.$set(_vm.area, "hora_trabajo", $$v)
            },
            expression: "area.hora_trabajo"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("td", [
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: { click: _vm.eliminar }
        },
        [_c("i", { staticClass: "fa fa-trash" })]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65108a82", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65108a82","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/sts/TrArea.vue
// module id = 391
// module chunks = 0